import { createSlice } from "@reduxjs/toolkit";
import { decodeJwtPayload } from "../utils/jwt";
import { normalizePermissions, parsePermissionList } from "../utils/permissions";

const tokenFromStorage = localStorage.getItem("accessToken");
const userFromStorage = localStorage.getItem("userProfile");
const permissionsFromStorage = localStorage.getItem("pos.permissions");
const sessionLockedFromStorage = localStorage.getItem("pos.session.locked");

const parsedUser = userFromStorage ? JSON.parse(userFromStorage) : null;
const tokenClaims = tokenFromStorage ? decodeJwtPayload(tokenFromStorage) : null;
const permissionsFromClaims = normalizePermissions(tokenClaims?.permissions);
const permissionsFromStorageValue = normalizePermissions(permissionsFromStorage);
const permissionsRawFromClaims = parsePermissionList(tokenClaims?.permissions);

const initialState = {
  token: tokenFromStorage || null,
  user: parsedUser
    ? {
        ...parsedUser,
        accessLevelId:
          parsedUser.accessLevelId || tokenClaims?.accessLevelId || null,
        accessLevel: parsedUser.accessLevel || tokenClaims?.accessLevel || null,
        displayName:
          parsedUser.displayName || tokenClaims?.displayName || null,
        storeId: parsedUser.storeId || tokenClaims?.storeId || null,
        permissionsRaw:
          parsedUser.permissionsRaw ||
          (permissionsRawFromClaims.length ? permissionsRawFromClaims : null) ||
          parsedUser.permissions ||
          permissionsFromStorageValue,
        permissions:
          parsedUser.permissions && parsedUser.permissions.length
            ? parsedUser.permissions
            : permissionsFromClaims.length
              ? permissionsFromClaims
              : permissionsFromStorageValue,
      }
    : null,
  isSessionLocked: sessionLockedFromStorage === "true",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token, user } = action.payload;
      state.token = token || null;
      state.user = user || null;
      state.isSessionLocked = false;
      if (token) {
        localStorage.setItem("accessToken", token);
      } else {
        localStorage.removeItem("accessToken");
      }
      if (user) {
        localStorage.setItem("userProfile", JSON.stringify(user));
      } else {
        localStorage.removeItem("userProfile");
      }
      const permissionsRaw = parsePermissionList(
        user?.permissionsRaw ?? user?.permissions,
      );
      const permissions = normalizePermissions(
        permissionsRaw.length ? permissionsRaw : user?.permissions,
      );
      if (permissionsRaw.length) {
        localStorage.setItem("pos.permissions.raw", JSON.stringify(permissionsRaw));
      } else {
        localStorage.removeItem("pos.permissions.raw");
      }
      if (permissions.length) {
        localStorage.setItem("pos.permissions", JSON.stringify(permissions));
      } else {
        localStorage.removeItem("pos.permissions");
      }
      localStorage.removeItem("pos.session.locked");
    },
    lockSession: (state) => {
      if (!state.token || !state.user) {
        return;
      }
      state.isSessionLocked = true;
      localStorage.setItem("pos.session.locked", "true");
    },
    unlockSession: (state) => {
      state.isSessionLocked = false;
      localStorage.removeItem("pos.session.locked");
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.isSessionLocked = false;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userProfile");
      localStorage.removeItem("pos.permissions.raw");
      localStorage.removeItem("pos.permissions");
      localStorage.removeItem("pos.session.locked");
    },
  },
});

export const { setCredentials, lockSession, unlockSession, logout } =
  authSlice.actions;
export default authSlice.reducer;
